import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { COMPANY, PRODUCTS } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src="/images/logo/kie-logo-sky.png"
                alt="KIE Logo"
                className="h-12 w-12 object-contain"
              />
              <img
                src="/images/logo/kie-eng-trans.png"
                alt="Sri Kashetter Industrial Essentials"
                className="h-10 object-contain"
              />
            </div>
            <p className="mt-5 text-sm text-[#94A3B8] leading-relaxed max-w-md">
              Trusted supplier of conveyor belts, bearings, gear boxes, motors and crusher
              wear-parts to mining, quarry and process plants across South India.
            </p>
            <div className="mt-6 text-xs uppercase tracking-[0.2em] text-[#94A3B8]">
              Proprietor: <span className="text-white">{COMPANY.proprietor}</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0EA5E9] mb-4">
              Top Products
            </div>
            <ul className="space-y-2 text-sm">
              {PRODUCTS.slice(0, 8).map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/products/${p.slug}`}
                    className="text-[#cbd5e1] hover:text-white transition-colors"
                  >
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0EA5E9] mb-4">
              Reach Us
            </div>
            <ul className="space-y-3 text-sm text-[#cbd5e1]">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 text-[#0EA5E9] shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-[#0EA5E9]" />
                <a href={COMPANY.phoneHref} className="hover:text-white">{COMPANY.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-[#0EA5E9]" />
                <a href={COMPANY.emailHref} className="hover:text-white">{COMPANY.email}</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0EA5E9] mb-4">
              Follow
            </div>
            <div className="flex gap-3">
              <a href={COMPANY.whatsapp} target="_blank" rel="noreferrer" className="p-2 bg-white/10 hover:bg-[#25D366] transition-colors" aria-label="WhatsApp" data-testid="footer-whatsapp">
                <MessageCircle size={18} />
              </a>
              <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="p-2 bg-white/10 hover:bg-[#0EA5E9] transition-colors" aria-label="Instagram" data-testid="footer-instagram">
                <Instagram size={18} />
              </a>
              <a href={COMPANY.facebook} target="_blank" rel="noreferrer" className="p-2 bg-white/10 hover:bg-[#1877F2] transition-colors" aria-label="Facebook" data-testid="footer-facebook">
                <Facebook size={18} />
              </a>
            </div>
            <Link
              to="/enquiry"
              className="mt-6 inline-block bg-[#0EA5E9] hover:bg-[#0284C7] px-5 py-3 text-xs font-bold uppercase tracking-[0.18em]"
              data-testid="footer-cta-quote"
            >
              Get Quote
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#94A3B8]">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link>
            <span className="text-white/20">·</span>
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
            <span className="text-white/20">·</span>
            <span>Proprietor: {COMPANY.proprietor} · Davangere, Karnataka, India</span>
          </div>
        </div>
      </div>

      <div className="bg-black/30 py-6">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 font-head font-black text-5xl md:text-7xl lg:text-[10rem] leading-[0.85] tracking-[-0.04em] text-white/5 select-none">
          KASHETTER
        </div>
      </div>
    </footer>
  );
}
